import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-content-between w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-left" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Administrare"),
    /*#__PURE__*/_createElementVNode("h5", { class: "mt-0" }, "Pacienți")
  ])
], -1)
const _hoisted_2 = { class: "app-inner-container" }

import { Patient } from '@/interfaces/Patient';
import PatientsService from '@/services/PatientsService';
import PatientList from '@/components/PatientList.vue';
import { onActivated, ref } from 'vue';
import Card from 'primevue/card';

const REFRESH_INTERVAL_MS = 10 * 60 * 1000;

// Vars definitions

export default /*#__PURE__*/_defineComponent({
  __name: 'PatientListView',
  setup(__props) {

const patients = ref<Patient[]>();
let lastFetchedAt = 0;

// Functions definitions
const fetchPatients = async () => {
  try {
    patients.value = (await PatientsService.fetchPatients()) as Patient[];
    lastFetchedAt = Date.now();
  } catch (error) {
    console.error(error as string);
  }
};

const refreshIfStale = () => {
  if (Date.now() - lastFetchedAt >= REFRESH_INTERVAL_MS) {
    fetchPatients();
  }
};

// Component actions
onActivated(refreshIfStale);

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createBlock(_unref(Card), null, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Toast),
        _createVNode(PatientList, { patients: patients.value }, null, 8, ["patients"])
      ])
    ]),
    _: 1
  }))
}
}

})